import { z } from 'zod';

export const AlertThresholdsSchema = z.object({
  warning: z.number().int().min(1).max(100).default(75),
  critical: z.number().int().min(1).max(100).default(90),
  limit: z.number().int().min(1).max(100).default(100),
});

export const CreateBudgetSchema = z
  .object({
    name: z.string().min(1, 'Budget name is required'),
    periodType: z.enum(['weekly', 'monthly', 'yearly']),
    status: z.enum(['active', 'closed']).optional(),
    endDate: z
      .string()
      .regex(/^\d{4}-\d{2}-\d{2}$/)
      .nullable()
      .optional(),
    alertThresholds: AlertThresholdsSchema.optional(),
    categoryLimits: z
      .array(
        z.object({
          categoryId: z.string().uuid(),
          amount: z.number().min(0),
        })
      )
      .min(1, 'At least one category limit is required'),
  })
  .superRefine((data, ctx) => {
    if (data.status === 'closed' && !data.endDate) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: 'End date is required when status is closed',
        path: ['endDate'],
      });
    }
  });

export type CreateBudgetSchemaInput = z.infer<typeof CreateBudgetSchema>;

export function validateCreateBudget(input: unknown) {
  return CreateBudgetSchema.safeParse(input);
}
